/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type representing an employee draft version
 */
export enum EmployeeDraftVersion {
    DRAFT = 'DRAFT',
}
